// export const GET_BOM_LIST = "GET_BOM_LIST"
// export const GET_BOM_LIST_SUCCESS = "GET_BOM_LIST_SUCCESS"

export const POST_GO_BUTTON_FOR_WORK_ORDER_MASTER = "POST_GO_BUTTON_FOR_WORK_ORDER_MASTER"
export const POST_GO_BUTTON_FOR_WORK_ORDER_MASTER_SUCCESS = "POST_GO_BUTTON_FOR_WORK_ORDER_MASTER_SUCCESS"

export const POST_WORK_ORDER_MASTER = "POST_WORK_ORDER_MASTER"
export const POST_WORK_ORDER_MASTER_SUCCESS = "POST_WORK_ORDER_MASTER_SUCCESS"

export const GET_WORK_ORDER_LIST_PAGE = "GET_WORK_ORDER_LIST_PAGE"
export const GET_WORK_ORDER_LIST_PAGE_SUCCESS = "GET_WORK_ORDER_LIST_PAGE_SUCCESS"

export const EDIT_WORK_ORDER_LIST_ID = "EDIT_WORK_ORDER_LIST_ID"
export const EDIT_WORK_ORDER_LIST_ID_SUCCESS = "EDIT_WORK_ORDER_LIST_ID_SUCCESS"

export const UPDATE_WORK_ORDER_LIST = "UPDATE_WORK_ORDER_LIST"
export const UPDATE_WORK_ORDER_LIST_SUCCESS = "UPDATE_WORK_ORDER_LIST_SUCCESS"

export const DELETE_WORK_ORDER_LIST_PAGE = "DELETE_WORK_ORDER_LIST_PAGE"
export const DELETE_WORK_ORDER_LIST_PAGE_SUCCESS = "DELETE_WORK_ORDER_LIST_PAGE_SUCCESS"


export const BULK_BOM_FOR_WORKORDER = "BULK_BOM_FOR_WORKORDER"
export const BULK_BOM_FOR_WORKORDER_SUCCESS = "BULK_BOM_FOR_WORKORDER_SUCCESS"

export const SAVE_BULK_BOM_FOR_WORKORDER = "SAVE_BULK_BOM_FOR_WORKORDER"
export const SAVE_BULK_BOM_FOR_WORKORDER_SUCCESS = "SAVE_BULK_BOM_FOR_WORKORDER_SUCCESS"

// 🔹 Force Complete Work Order
export const FORCE_COMPLETE_WORK_ORDER = "FORCE_COMPLETE_WORK_ORDER"
export const FORCE_COMPLETE_WORK_ORDER_SUCCESS = "FORCE_COMPLETE_WORK_ORDER_SUCCESS"

export const RESET_FORCE_COMPLETE_MSG = "RESET_FORCE_COMPLETE_MSG";


export const WORK_ORDER_API_ERROR_ACTION = "WORK_ORDER_API_ERROR_ACTION"


